import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./AzureAdLogin/AuthConfig.ts";
import ReactDOM from "react-dom";
import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = new PublicClientApplication(msalConfig);

import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import RoutesComponent from "./Routes/routes.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      {/* {" "} */}
      <MsalProvider instance={msalInstance}>
      <App />
      </MsalProvider>
    </BrowserRouter>
  </StrictMode>
);
